<cmps-dialog class="cmps-pillar-view-dialog--dialog">
    <cmps-dialog-header class="cmps-pillar-view-dialog--dialog-header">
        <cmps-insight-coaching-performance
            *ngIf="!_dialogData?.id"
            [label]="_i18n._9945_TOTAL_PERFORMANCE | translate"
            [isTotalPerformance]="true"
            [data]="
                state?.userData?.[_dialogData.user.userId]
                    ?.totalPerformancePillar?.parentPillar.progressBarData
            "
            [actionButtons]="actionButtonsTemplate"
            [user]="_dialogData.user"
            (selectedValue)="_onSelectPillar($event, true)"
            (onUserClickAction)="_onSelectUser($event); overlayRef.toggle()"
            [cmpsOverlayTrigger]="userQuickAccessTpl"
            cmpsOverlayTriggerTrigger="none"
            #overlayRef="cmpsOverlayTrigger"
        ></cmps-insight-coaching-performance>

        <ng-template #closeButtonTemplate>
            <button
                class="cmps-icon-button--no-bg cmps-user-selection-close"
                cmpsIconButton
                [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                trigger="hover"
                (click)="_onCloseClick()"
            >
                <cmps-icon
                    class="cmps-user-selection-close-icon--default"
                    svgIcon="close"
                ></cmps-icon>
                <cmps-icon
                    class="cmps-user-selection-close-icon--hover"
                    svgIcon="close-box"
                ></cmps-icon>
            </button>
        </ng-template>

        <ng-template #actionButtonsTemplate>
            <div class="cmps-insight-coaching-performance--action-buttons">
                <ng-container *ngIf="!hideNavigationButtons">
                    <button
                        class="cmps-icon-button--no-bg"
                        [disabled]="_currentHistoryIndex <= 0"
                        cmpsIconButton
                        [cmpsTooltipTrigger]="_i18n._11219_GO_BACK | translate"
                        trigger="hover"
                        (click)="_onBackClick()"
                    >
                        <cmps-icon svgIcon="arrow-left"></cmps-icon>
                    </button>
                    <button
                        class="cmps-icon-button--no-bg"
                        cmpsIconButton
                        [disabled]="
                            _currentHistoryIndex >= _visitedUserIds.length - 1
                        "
                        [cmpsTooltipTrigger]="
                            _i18n._11220_GO_FORWARD | translate
                        "
                        trigger="hover"
                        (click)="_onNextClick()"
                    >
                        <cmps-icon svgIcon="arrow-right"></cmps-icon>
                    </button>
                    <button
                        class="cmps-icon-button--no-bg"
                        cmpsIconButton
                        [cmpsTooltipTrigger]="
                            (!_dialogRef.expanded
                                ? _i18n._11217_FULLSCREEN
                                : _i18n._11218_REDUCE
                            ) | translate
                        "
                        trigger="hover"
                        (click)="
                            !_dialogRef.expanded
                                ? _dialogRef.expand()
                                : _dialogRef.collapse()
                        "
                    >
                        <cmps-icon
                            [svgIcon]="
                                !_dialogRef.expanded
                                    ? 'arrow-expand'
                                    : 'arrow-collapse'
                            "
                        ></cmps-icon>
                    </button>
                </ng-container>

                <ng-container
                    *ngTemplateOutlet="closeButtonTemplate"
                ></ng-container>
            </div>
        </ng-template>

        <cmps-insight-coaching-performance
            *ngIf="_dialogData?.id"
            [label]="_selectedPillarLabel"
            [isTotalPerformance]="true"
            [actionButtons]="closeButtonTemplate"
            (selectedValue)="_onSelectPillar($event, true)"
        ></cmps-insight-coaching-performance>
    </cmps-dialog-header>

    <cmps-dialog-body>
        <div class="onppup-body">
            <div class="cmps-pillar-view-dialog-container">
                <div
                    class="cmps-insight-coaching-performance-container"
                    *ngFor="
                        let pillar of state?.userData?.[_dialogData.user.userId]
                            ?.pillarsData;
                        let i = index
                    "
                >
                    <ng-container
                        *ngIf="!_dialogData?.id || pillar.id === _dialogData.id"
                    >
                        <cmps-insight-coaching-performance
                            [label]="pillar.parentPillar.titleLabel"
                            [isTotalPerformance]="false"
                            [data]="pillar.parentPillar.progressBarData"
                            (selectedValue)="_onSelectPillar($event, false)"
                        ></cmps-insight-coaching-performance>

                        <div #childPillars>
                            <ng-container
                                *ngFor="let cc of pillar.childPillars"
                            >
                                <cmps-metric-performance
                                    *ngIf="cc.isVisible"
                                    [metricData]="cc"
                                    (toggleExpand)="
                                        _onTogglePillar(pillar.id, cc.metricId)
                                    "
                                ></cmps-metric-performance>
                                <ng-container
                                    *ngIf="
                                        cc.childRows?.length && cc.isExpanded
                                    "
                                >
                                    <ng-container
                                        *ngFor="
                                            let childRow of cc.childRows;
                                            let last = last
                                        "
                                    >
                                        <cmps-metric-performance
                                            [class.cmps-metric-performance--last-child]="
                                                last
                                            "
                                            *ngIf="childRow.isVisible"
                                            [metricData]="childRow"
                                            [showTrend]="false"
                                            [last-child]="last"
                                            (onUserClickAction)="
                                                _onSelectUser($event)
                                            "
                                        >
                                        </cmps-metric-performance>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>

<ng-template
    let-overlay="overlay"
    #userQuickAccessTpl
>
    <cmps-quick-access
        [overlay]="overlay"
        (userSelect)="_onUserSelect($event)"
    ></cmps-quick-access>
</ng-template>
